import type { FaireProductEntity } from "../../entity_types/product";

export const p_a5bvgwy2zx: FaireProductEntity = {
  token: "p_a5bvgwy2zx",
  type: "product",
  name: "Mexican Chocolate Almond Walking Tamales, 7 Pouches/Case",
  brandToken: "b_2punudte8l",
  brandName: "FILLO'S",
  imageUrl:
    "https://cdn.faire.com/fastly/b7278f47272f0422608ba4e605f841cff73af4354526666708c779f5ee56096c.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a0d2cb5712f84951fc3d592d87c4e245ef1a24e00fa820efe06baddf9ad1d795.png",
  ],
  priceDollars: 18,
  description:
    "Simple ingredients and real sabor at hand, wherever you’re headed.\n\nNon-GMO Project Verified, Shelf-stable, ready to eat, vegan friendly, plant protein, made with Extra Virgin Olive Oil",
  tags: [],
  msrpDollars: 36,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:56:12.327Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
